import React from 'react'
import {Helmet} from 'react-helmet'

import Layout from '../components/layout'
import Carrusel from '../components/carrusel/Carrusel'
import MacroloteInfo from '../components/macrolotes/MacroloteInfo'
import PlanoMacrolote from '../components/macrolotes/PlanoMacrolote'
import FormularioContacto from '../components/formulario'
const Macrolotes = ({ pageContext }) => {
  const {name, images, info, mapas, fichaTecnica, english} = pageContext
  
  const imgs = [
    {
      imagen : images[0],
      descripcion : name,
      direccion: 'izquierda',
    }
  ]
  return (
    <Layout english={english}>
        <Helmet defer={false}>
            <meta charSet="utf-8" />
            <title>Macrolote {name}</title>
            <meta name="description" content={
              english ? 
                `Development opportunity for ${info[5].dato}, Acapulco`
                :
                `Para desarrollo ${info[5].dato}, Acapulco`
            } />
        </Helmet>
        <Carrusel imgs={imgs} />
        <MacroloteInfo info={info} english={english} />
        <PlanoMacrolote mapas={mapas} ficha={fichaTecnica} english={english} />
        <FormularioContacto english={english} />
    </Layout>
  )
}

export default Macrolotes